function ticarisec(id) {

    if (id == '1') {
        $('#ticarivar').hide("fast");
        $('#ticariyok').show("fast");
    }
    else {
        $('#ticariyok').hide("fast");
        $('#ticarivar').show("fast");
    }
}

function ortaksec(id) {
    if (id == '0') {
        $('#ortakvar').hide("fast");
    }
    else {
        $('#ortakvar').show("fast");
    }
}

function magazasec(id) {
    if (id == '0') {
        $('#magazasiyok').hide("fast");
        $('#magazadusunuyor').hide("fast");
        $('#magazasivar').show("fast");
    }
    else if (id == '1') {
        $('#magazasiyok').hide("fast");
        $('#magazasivar').hide("fast");
        $('#magazadusunuyor').show("fast");
    }
    else if (id == '2') {
        $('#magazasivar').hide("fast");
        $('#magazadusunuyor').hide("fast");
        $('#magazasiyok').show("fast");
    }
}

function ilcegoster(il, tip) {

    if (il != null && tip != null) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + '/p/Contact/GetTownsByCityName',
            data: 'cityName=' + il,
            //url: "/Contact/GetTownsByCityName?cityName="+il,
            dataType: 'json',
            success: function (dt) {

                $select = $("#iilce");

                switch (tip) {

                    case "i": $select = $("#iilce"); break;
                    case "s": $select = $("#silce"); break;
                    case "m": $select = $("#milce"); break;
                    case "d": $select = $("#dilce"); break;
                    case "y": $select = $("#yilce"); break;

                }

                $select.find('option').remove();

                $select
                     .append($("<option selected='selected' ></option>")
                     .attr("value", "")
                     .text("Lütfen Seçin"));

                for (var i = 0; i < dt.length; i++) {

                    $select
                     .append($("<option></option>")
                     .attr("value", dt[i].Name)
                     .text(dt[i].Name));

                }

                if ($('#secondstep input[name="magaza"]:checked').length > 0) {
                    magazasec($('#secondstep input[name="magaza"]:checked').val());
                }

            }
        });
    }
    


}


$(document).ready(function () {

    $(".TicariSec input").removeAttr("checked");
    $('input[name="magaza"], input[name="mvs92"], input[name="s9b"], input[name="s12c"], input[name="s11d"], input[name="s11d"], input[name="s15a"], input[name="s14b"] , input[name="s18a"]').removeAttr("checked");

    $("#Bayilikformgonder").on("click", function () {

        $("#PstResult").html("");
        $("#AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + '/p/Contact/DealerAppTake',
            cache: false,
            data: $('#BayilikForm').serialize(),
            success: function (data) {

                $("#AjaxLoader").hide();
                $("#PstResult").show();
                $("#PstResult").html(data);

                if ($(".SuccessArea").length > 0) {
                    $("#BayilikForm > div, .nextb, .prevb, .gonderb").hide();
                    $("#PstResult").show();
                }
                else {

                }

            }
        });

        return false;

    });

    $("#BayilikForm .label_radio input").on("change", function () {

        var name = $(this).attr("name");

        $("#BayilikForm input[name='" + name + "']").each(function (e) {
            $(this).closest("label").removeClass("r_on");
        });

        if ($(this).is(":checked")) {

            $(this).closest("label").addClass("r_on");

        }


    });

    var StepCount = $("#steps > li").length - 1;
    var CurStep = $("#steps > li.current").index();
    var StepIsValid = true;


    function ValidateStep(i) {

        // alert("aaaaaassxx " + i);
        var IsValid = false;

        var stepName = "step" + i;

        $("#" + stepName + " *").removeClass("NotValid");

        $('#hatalar').html('').hide();
        var error = 0;

        if (i == 1) {

            var fields = $('#firststep input:not(#fax), #firststep select, #firststep textarea');

            fields.each(function () {

                var value = $(this).val();
                var ne = $(this).attr('id');
                //console.log(ne);

                switch (ne) {
                    case 'mail':
                        var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                        if (emailPattern.test(value)) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");

                            error++;
                            $('#hatalar').append('&bull; Geçerli Bir mail adresi girmelisiniz.<br>').show();
                        }
                        break;
                    case 'tc':
                        if (value.length > 0) {
                            var tckontrol, toplam1, toplam2, sonuc, carpim, fark, mod;
                            tckontrol = value;
                            tcno = value;
                            toplam1 = Number(tcno.substring(0, 1)) + Number(tcno.substring(2, 3)) + Number(tcno.substring(4, 5)) + Number(tcno.substring(6, 7)) + Number(tcno.substring(8, 9));
                            toplam2 = Number(tcno.substring(1, 2)) + Number(tcno.substring(3, 4)) + Number(tcno.substring(5, 6)) + Number(tcno.substring(7, 8));
                            carpim = toplam1 * 7;
                            fark = carpim - toplam2;
                            if (fark < 0) {
                                fark = fark + 10;
                            }
                            mod = fark % 10;
                            if (mod == tcno.substring(9, 10)) {
                                var lastDigit = value % 10;
                                var sum = 0;
                                for (var i = 0; i < 10; ++i) {
                                    sum += Number(value.substring(i, i + 1));
                                }
                                var checksumDigit = sum % 10;
                                if (checksumDigit == lastDigit) {
                                    $(this).addClass('valid');
                                } else {
                                    //$(this).effect("shake", { times: 3 }, 50);
                                    $(this).addClass("NotValid");
                                    error++;
                                    $('#hatalar').append('&bull; Geçerli Bir TC Kimlik Numarası girmelisiniz.<br>').show();
                                }
                            } else {
                                //$(this).effect("shake", { times: 3 }, 50);
                                $(this).addClass("NotValid");
                                error++;
                                $('#hatalar').append('&bull; Geçerli Bir TC Kimlik Numarası girmelisiniz.<br>').show();
                            }
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; Geçerli Bir TC Kimlik Numarası girmelisiniz.<br>').show();
                        }

                        break;
                    case 'ogrenim':
                        if (value != 0) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");

                            error++;
                            $('#hatalar').append('&bull; Öğrenim Durumunu Belirtmeniz Gerekmektedir.<br>').show();
                        }
                        break;

                    case 'isim':
                        if (value.length > 4) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; Ad ve Soyad Bilgisi yetersiz. Lütfen Kontrol Ediniz.<br>').show();
                        }
                        break;
                    case 'dogum':
                        if (value.length > 4) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; Doğum Yeri ve Tarihi Bilgisi yetersiz. Lütfen Kontrol Ediniz.<br>').show();
                        }
                        break;
                    case 'iadres':
                        if (value.length > 10) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; Adres Bilgisi yetersiz. Lütfen Kontrol Ediniz.<br>').show();
                        }
                        break;
                    case 'iil':
                        if (value.length > 2) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; İl Bilgisi yetersiz. Lütfen Kontrol Ediniz.<br>').show();
                        }
                        break;
                    case 'iilce':
                        if (value.length > 2) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; İlçe Bilgisi yetersiz. Lütfen Kontrol Ediniz.<br>').show();
                        }
                        break;
                    case 'tel':
                        if (value.length > 9) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; Telefon Bilgisi yetersiz. Lütfen Alan Kodu ile Birlikte yazınız.<br>').show();
                        }
                        break;
                    case 'gsm':
                        if (value.length > 9) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; Cep Telefonu Bilgisi yetersiz. Lütfen Alan Kodu ile Birlikte yazınız.<br>').show();
                        }
                        break;
                    default:
                        if (value.length > 4) {
                            $(this).addClass('valid');
                        } else {
                            //$(this).effect("shake", { times: 3 }, 50);
                            $(this).addClass("NotValid");
                            error++;
                            $('#hatalar').append('&bull; Tüm alanların doldurulması gerekmektedir.<br>').show();
                        }
                        break;
                }

            });
            if (error == 0) {
                gidebilir(stepName, i);
                IsValid = true;
            }
        } else if (i == 2) {
            var error = 0;
            var fields = $('#secondstep input[name="ticari"]:checked');
            if (fields.length < 1) {
                alert('Lütfen uygun ticari tanımınızı seçiniz');
                error++;
            }

            if (error == 0) {
                gidebilir(stepName, i);
                IsValid = true;
            }
        } else if (i == 3) {
            var error = 0;
            var fields = $('#thirdstep input[name="magaza"]:checked');
            if (fields.length < 1) {
                alert('Lütfen Mağaza durumunuzu seçiniz');
                error++;
            }
            if (error == 0) {
                gidebilir(stepName, i);
                IsValid = true;
            }
        } else {
            //$("#" + stepName).hide();
            //$("#step" + (i + 1)).show();
            //if (i + 2 == StepCount)
            //    $(submmitButtonName).show();
            //selectStep(i + 1);
        }

        // console.log($("#hatalar").html() + " - " + error);

        if (error == 0) {

            IsValid = true;
        }

        return IsValid;

    }

    function gidebilir(step, adim) {

        //$("#" + step).hide();
        //$("#step" + (adim + 1)).show();

        if (adim == StepCount) {

            $("#SubmitBayi, #SubmitBayi > input").show();
            $(".nextb").hide();
        }
        else {
            $(".nextb").show();
        }

        $("#PstResult").hide();

        //selectStep(adim + 1);
    }

    $("#step1Prev, #step1Next").on("click", function () {

        var isNext = $(this).hasClass("nextb");
        var isStepChanged = false;


        if (isNext) {
            StepIsValid = ValidateStep(CurStep);

            if (StepIsValid) {
                CurStep++;
                isStepChanged = true;
            }

        }

        if (!isNext && CurStep > 0) {
            CurStep--;
            isStepChanged = true;
        }

        if (isStepChanged) {

            $("#steps > li").removeClass("current");
            $("#steps > #stepDesc" + CurStep).addClass("current");

            $("#BayilikForm > div").removeClass("CurStep");
            $("#BayilikForm > #step" + CurStep).addClass("CurStep");
        }

        //console.log(CurStep);

        if (CurStep == 0) {
            $(".prevb").hide();
        }
        else {
            $(".prevb").show();
        }

        if (CurStep == StepCount) {
            $(".gonderb").show();
            $(".nextb").hide();
        }
        else {
            $(".nextb").show();
            $(".gonderb").hide();
        }

    });


    $("#BayilikForm input").on("keypress", function () {
        $(this).removeClass("Valid");
    });



    $("#BayilikForm input").on("click", function () {
        $(this).removeClass("Valid");
    });



});